<template>
    <div id="index" @drop.prevent @dragover.prevent oncontextmenu="return false;">
        <router-view></router-view>
<!--        <button class="temp-btn" v-on:click="test">Alert</button>-->
    </div>
</template>

<script>
    import {bus} from "../vue_bus";
    import ModalAlert from "./Modal/ModalAlert";
    import TempCopyRight from "./TempCopyRight";
    import ModalSuccess from "./Modal/ModalSuccess";

    export default {
        name: "TheApp",
        components: {TempCopyRight},
        // methods: {
        //     test() {
        //         bus.$emit('showModalAlert', 'Вы делаете что попало!');
        //     }
        // },
        mounted() {
            bus.$on("showModalAlert", (text) => {
                this.$modal.show(ModalAlert, {text}, {
                    name: 'modalAlert',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            });
            bus.$on("showModalSuccess", (text) => {
                this.$modal.show(ModalSuccess, {text}, {
                    name: 'modalAlert',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            });
        }
    }
</script>

<style scoped>
    #index {
        display: block;
        width: 100vw;
        height: 100vh;
    }
</style>

<style>
    .red-rectangle-button-of-love {
        border: 2px solid #D83336;
        padding: 10px 25px 10px 25px;
        background-color: #D83336;
        color: white;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .red-rectangle-button-of-love:hover {
        background-color: #b82325;
        border-color: #b82325;
    }

    .red-rectangle-button-of-love:active {
        background-color: #ad0e27;
        border-color: #ad0e27;
    }

    .red-pill-button-of-hate {
        border-radius: 50px;
        border: 2px solid #D83336;
        background-color: #D83336;
        color: white;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .red-pill-button-of-hate:hover {
        background-color: #b82325;
        border-color: #b82325;
    }

    .red-pill-button-of-hate:active {
        background-color: #ad0e27;
        border-color: #ad0e27;
    }

    .disabled-pill-button-of-hate {
        border-radius: 50px;
        border: 2px solid #ACACAC;
        background-color: #ACACAC;
        color: white;
        font-weight: bold;
        text-align: center;
        cursor: not-allowed;
        user-select: none;
    }

    .grey-outline-pill-button {
        border-radius: 50px;
        border: 2px solid #939393;
        padding: 10px 25px 10px 25px;
        color: #939393;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .grey-outline-pill-button:hover {
        color: #838383;
        border-color: #838383;
    }

    .grey-outline-pill-button:active {
        color: #737373;
        border-color: #737373;
    }

    .bold-text {
        font-weight: bold;
    }

    .sidebar-main-label-grid {
        display: grid;
        grid-template-columns: auto 40px;
        grid-column-gap: 10px;
    }

    .sidebar-main-label {
        font-weight: bold;
        color: #303030;
    }

    .collapsable-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .sidebar-step-two-img {
        width: 100%;
        height: auto;
        box-sizing: border-box;
    }

    .lb-grid {
        display: grid;
        grid-template-columns: auto max-content;
    }

    #projects-page {
        display: block;
        width: 100%;
        height: 100%;
    }

    .projects-page-outer {
        display: block;
        width: 100%;
        height: 100%;
    }

    .is-blurred {
        background-size: cover;
        -webkit-filter: blur(0.3em);
        -moz-filter: blur(0.3em);
        -ms-filter: blur(0.3em);
        -o-filter: blur(0.3em);
        filter: blur(0.3em);
    }

    @media screen and (max-height: 800px) {
        #configurator-group {
            display: inline-flex;
            height: calc(100% - 62px);
            box-sizing: border-box;
        }
        .step-text{
            font-size: 12px;
        }
        /*.sidenav{*/
        /*    width: 240px;*/
        /*}*/
        .sidebar-main-label{
            font-size: 16px;
        }
        #workspace {
            width: calc(100vw - 420px);
            height: calc(100% - 55px);
        }

        #workspace-lite-wide {
            width: 100vw;
            height: 100%;
        }

        #workspace-ap {
            width: calc(100vw - 320px);
            height: calc(100vh - 80px);
        }

        .workspace-admin-scroll-part {
            height: calc(100vh - 201px);
        }
        .grey-outline-pill-button {
            height: 20px;
            font-size: 16px;
            padding: 8px 23px 10px 23px;
        }
        .red-pill-button-of-hate {
            height: 20px;
            font-size: 16px;
            padding: 8px 23px 10px 23px;
        }
        .disabled-pill-button-of-hate {
            height: 20px;
            font-size: 16px;
            padding: 8px 23px 10px 23px;
        }
        .extra-left-margin {
            margin-left: 10px;
        }
        .lb-btn-container {
            padding: 5px 10px;
        }
        .photo-lower-bar-button-group {
            padding-left: 5px;
            font-size: 14px;
        }
        .photo-lower-bar-button {
            padding: 12px 12px;
        }
        .photo-lower-bar-button-custom {
            padding: 12px 12px;
        }
        .sidebar-step-two-img-container {
            margin: 10px 0;
        }
        .sidebar-text-area {
            margin: 10px 0;
            font-size: 12px;
        }
        .sidebar-step-two-img {
            max-height: 200px;
        }
        .red-rectangle-button-of-love {
            height: 25px;
            font-size: 14px;
        }
        .lb-svg {
            height: 20px;
            width: auto;
        }
        .lb-svg-rotate {
            height: 24px;
            width: auto;
        }

        .lite-navbar-button {
            margin-top: 10px;
        }
    }

    @media screen and (min-height: 800px) {
        #configurator-group {
            display: inline-flex;
            height: calc(100% - 82px);
            box-sizing: border-box;
        }
        .step-text{
            font-size: 15px;
        }
        .sidebar-main-label{
            font-size: 23px;
        }
        #workspace {
            width: calc(100vw - 420px);
            height: calc(100% - 70px);
        }

        #workspace-lite-wide {
            width: 100vw;
            height: 100%;
        }

        #workspace-ap {
            width: calc(100vw - 320px);
            height: calc(100vh - 80px);
        }

        .workspace-admin-scroll-part {
            height: calc(100vh - 201px);
        }

        .grey-outline-pill-button {
            height: 25px;
            font-size: 18px;
            padding: 10px 25px 10px 25px;
        }
        .red-pill-button-of-hate {
            height: 25px;
            font-size: 18px;
            padding: 10px 25px 10px 25px;
        }
        .disabled-pill-button-of-hate {
            height: 25px;
            font-size: 18px;
            padding: 10px 25px 10px 25px;
        }
        .extra-left-margin {
            margin-left: 20px;
        }
        .lb-btn-container {
            padding: 11px 30px;
        }
        .photo-lower-bar-button-group {
            padding-left: 40px;
        }
        .photo-lower-bar-button {
            padding: 22px 20px;
        }
        .photo-lower-bar-button-custom {
            padding: 22px 20px;
        }
        .sidebar-step-two-img-container {
            margin: 40px 0;
        }
        .sidebar-text-area {
            margin: 20px 0;
            font-size: 12px;
        }
        .sidebar-step-two-img {
            max-height: 450px;
        }
        .red-rectangle-button-of-love {
            height: 25px;
            font-size: 18px;
        }
        .lb-svg {
            height: 24px;
            width: auto;
        }
        .lb-svg-rotate {
            height: 28px;
            width: auto;
        }
    }

    #workspace-lite {
        width: calc(100vw - 320px);
        height: calc(100% - 120px);
        /*height: 100%;*/
    }
    .lb-btn-container {
        display: inline-flex;
        justify-content: flex-end;
    }

    .lb-btn-single-center-container {
        padding: 11px 30px;
        display: inline-flex;
        justify-content: center;
    }

    .no-left-padding {
        padding-left: 0 !important;
    }

    .no-right-padding {
        padding-right: 0 !important;
    }

    .extra-left-padding {
        padding-left: 10px;
    }


    .sidebar-menu-container {
        margin: 20px;
        height: auto;
        /*overflow-x: hidden;*/
        /*overflow-y: auto;*/
    }

    .sidebar-sub-label {
        margin: 20px 0;
        font-size: 18px;
        font-weight: bold;
    }

    .sidebar-text {
        margin: 20px 0;
        font-size: 14px;
    }

    .sidenav {
        height: 100%;
        border-right: 2px solid #F2F2F2;
        z-index: 9;
        background-color: white;
        overflow-x: hidden;
        box-sizing: border-box;
        flex-grow: 0;
        flex-shrink: 0;
        width: 320px;
    }

    .sidenav-lite {
      overflow-y: hidden;
        border-right: 1px solid #ededed;
    }

    .lite-sidebar-upper {
      width: 100%;
      height: calc(100% - 79px);
      overflow-y: auto;
      overflow-x: hidden;
    }

    .lite-sidebar-lower {
        width: 100%;
        height: 79px;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: 0 20px;
    }

    .workspace-module-container {
        display: block;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }



    #lower-bar {
        border-top: 2px solid #F2F2F2;
    }

    .lower-bar-lite {
        border-top: 1px solid #ededed;
        height: 120px;
    }

    .lower-bar-lite-grid {
        display: grid;
        grid-template-rows: max-content auto;
    }

    .photo-lower-bar-button-group {
        white-space: nowrap;
        display: inline-flex;
        /*justify-content: center;*/
        align-items: center;
    }

    .photo-lower-bar-button {
        display: inline-flex;
        color: #939393;
        cursor: pointer;
        user-select: none;
    }

    .photo-lower-bar-button:hover {
        color: #808080;
    }

    .photo-lower-bar-button:active {
        color: #707070;
    }

    .projects-lite-lower-bar-button {
        display: inline-flex;
        padding: 22px 20px;
        color: #939393;
        cursor: pointer;
        user-select: none;
    }

    .projects-lite-lower-bar-button:hover {
        color: #808080;
    }

    .projects-lite-lower-bar-button:active {
        color: #707070;
    }

    .photo-lower-bar-button-text {
        position: relative;
        /*bottom: 4px;*/
        /*padding-bottom: 5px;*/
        /*font-size: 20px;*/
        font-weight: bold;
    }

    .photo-lower-bar-not-button-text {
        position: relative;
        bottom: 4px;
        /*font-size: 20px;*/
        font-weight: bold;
    }

    .photo-lower-bar-not-button {
        display: inline-flex;
        padding: 22px 20px;
        color: #939393;
        user-select: none;
    }

    .planes-dropdown-label {
        margin: 15px 15px 15px 0;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        user-select: none;
        display: inline-flex;
    }

    .planes-dropdown-label-static {
        margin: 15px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        user-select: none;
        display: inline-flex;
    }

    .planes-dropdown-label:hover {
        color: #404040;
    }

    .planes-dropdown-label:active {
        color: #303030;
    }

    .planes-dropdown-list {
        margin: 20px;
    }

    .planes-dropdown-list-item {
        font-size: 20px;
        font-weight: bold;
        margin: 10px 0;
        cursor: pointer;
        user-select: none;
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 10px;
    }

    .planes-dropdown-list-item:hover {
        color: #d83336;
    }

    .planes-dropdown-list-item:active {
        color: #b82325;
    }

    .planes-dropdown-group-inner-item {
        font-size: 18px;
        padding: 10px 10px;
        cursor: pointer;
        user-select: none;
        /*background-color: #F2F2F2;*/
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 10px;
        border-left: 2px solid transparent;
    }

    .planes-dropdown-group-inner-item:hover {
        color: #d83336;
        border-left: 2px solid #d83336;
        z-index: 100;
    }

    .planes-dropdown-group-inner-item:active {
        color: #b82325;
        border-left: 2px solid #b82325;
    }

    .active-photo {
        border: 2px solid #d83336 !important;
    }

    .project-preview {
        display: inline-block;
        background-color: white;
        margin: 10px;
        width: 300px;
        height: 195px;
        border-radius: 4px;
        border: 2px solid #f2f2f2;
        user-select: none;
    }

    .project-preview:hover {
        border: 2px solid #bdbdbd;
    }

    .project-preview:active {
        border: 2px solid #d83336;
    }

    .project-preview-sidebar {
        display: block;
        background-color: white;
        width: 276px;
        height: 165px;
        border-radius: 4px;
        border: 2px solid #f2f2f2;
        margin-bottom: 20px;
    }

    .active-project {
        border: 2px solid #d83336 !important;
    }

    .project-preview-image-container {
      width: 100%;
      height: 100%;
      /*width: 100%;*/
      /*height: 100%;*/
      /*display: flex;*/
      border-radius: 4px;
      /*justify-content: center;*/
    }

    .project-preview-image-container:hover {
      box-shadow: 0 0 8px 8px rgba(185,28,35, 0.4);
    }


    .project-preview-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        /*height: 200px;*/
        aspect-ratio: 3 / 2;
        /*border-radius: 2px;*/
        object-fit: cover;
        /*object-position: 0 0;*/
        object-position: center;
        display: block;

    }

    .project-preview-text-container {
        position: relative;
        bottom: 44px;
        height: 30px;
        padding-left: 15px;
        padding-top: 10px;
        background: rgba(0, 0, 0, 0.1);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        border-radius: 0 0 2px 2px;
        color: white;
        font-size: 14px;
    }

    .sidebar-borderline {
        margin: 15px 0;
        border-bottom: 2px solid #F2F2F2;
    }

    .modal-borderline {
        margin: 15px 30px;
        border-bottom: 2px solid #F2F2F2;
    }

    .modal-grid-two-cols {
        display: grid;
        grid-template-columns: 50% 50%;
        /*grid-column-gap: 10px;*/
        /*grid-row-gap: 10px;*/
    }

    .stripe {
        background-color: #F2F2F2;
    }

    .important-text {
        color: #d83336;
    }

    .sidebar-project-img {
        width: 100%;
        height: auto;
        border-radius: 2px;
        border: 2px solid white;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
    }

    .sidebar-project-img:hover {
        border: 2px solid #ACACAC;
    }

    .sidebar-project-img:active {
        border: 2px solid #d83336;
    }

    /*    Modal*/

    .modal-img-container {
        width: 100%;
        height: auto;
    }

    .modal-img {
        width: 100%;
        max-height: 250px;
    }

    .modal-close-btn-point {
        position: absolute;
        /*bottom: 265px;*/
        top: 9px;
        /*left: 530px;*/
        right: 59px;
        width: 0;
        height: 0;
    }

    .modal-close-btn {
        cursor: pointer;
    }
    .modal-close-btn:hover .modal-close-circle {
        fill: #b82325;
    }

    .modal-close-btn:active .modal-close-circle {
        fill: #ad0e27;
    }

    .modal-title {
        margin: 30px;
        font-weight: bold;
        font-size: 20px;
        color: #303030;
    }

    .modal-close-btn-container{
        display: flex;
        width: max-content;
        height: max-content;
        justify-content: center;
        align-items: center;
    }

    .modal-title-big {
        padding: 30px;
        font-weight: bold;
        font-size: 22px;
        color: #303030;
    }

    .modal-text {
        margin: 30px;
        font-size: 16px;
    }

    .modal-list {
        margin: 20px 10px;
        padding: 0;
        /*font-size: 18px;*/
    }

    .modal-text-input {
        width: calc(100% - 82px);
        padding: 10px;
        margin: 10px 30px;
        border: 1px solid #BDBDBD;
    }

    .modal-photo-carousel {
        display: flex;
        justify-content: safe center;
        margin: 0 30px;
        /*width: 100%;*/
        height: 220px;
        /*overflow-x: auto;*/
        /*overflow-y: hidden;*/
    }

    .modal-photo-carousel-element {
        display: inline;
        width: auto;
        height: 200px;
        margin-right: 10px;
    }

    .modal-button {
        background-color: #383838;
        padding: 10px 20px;
        margin: 30px;
        color: white;
        font-weight: bold;
        width: max-content;
        cursor: pointer;
        user-select: none;
        text-align: center;
        font-size: 14px;
    }

    .modal-button-auto-width {
        width: auto;
    }

    .modal-button:hover {
        background-color: #404040;
    }

    .modal-button:active {
        background-color: #383838;
    }

    .cd-modal-grid {
        display: grid;
        grid-template-columns: auto auto;
        margin: 20px 10px;
    }

    .cd-modal-grid-element {
        margin: 0 20px;
    }

    .cd-modal-text {
        font-size: 18px;
    }

    ul {
        list-style: none;
        padding-left: 20px;
    }

    .modal-list::before {
        content: "•";
        color: #d83336;
    }

    .cd-modal-list {
        margin: 10px;
        padding: 0;
        /*font-size: 16px;*/
    }

    .cd-modal-list::before {
        content: "•";
        color: #d83336;
    }

    .dnd-container {
        text-align: center;
        cursor: pointer;
    }

    .dnd-container-dragover {
        background-color: darkgray;
    }

    .cd-modal-text-input {
        width: available;
        width: -moz-available;
        width: -webkit-fill-available;
        padding: 10px;
        border: 1px solid #BDBDBD;
        outline: none;
    }

    .modal-data-container {
        margin-bottom: 30px;
    }

    .cd-select {
        color: #767676;
    }

    .cd-modal-text-input:hover {
        border-color: #828282;
    }

    .cd-modal-text-input:focus {
        border-color: #828282;
    }

    .red-text {
        color: #D83336;
    }

    .add-padding {
        padding: 0 20px;
    }

    .ap-modal-element {
        margin: 10px 30px
    }

    .no-margin-top {
        margin-top: 0;
    }

    .ap-product-modal-img {
        display: block;
        margin: 5px 30px;
        width: 200px;
        height: 134px;
        object-fit: cover;
    }

    .ap-product-modal-button {
        width: 180px;
        margin: 5px 30px;
        text-align: center;
    }

    .ap-product-modal-button-thin {
        width: 180px;
        text-align: center;
    }

    .ap-red-text-field {
        background-color: #f2f2f2;
        font-weight: bold;
        padding: 5px 10px;
        text-align: center;
        font-size: 16px;
        width: 179px;
        border-left: 2px solid #e4373a;
    }

    .ap-modal-select {
        display: block;
        /*font-size: 18px;*/
        width: 198px;
        height: 38px;
        padding: 10px;
    }

    .extra-top-margin {
        margin-top: 20px;
    }

    .ap-loader-grid {
        display: grid;
        grid-template-columns: 40px max-content;
        width: max-content;
        margin: 30px auto;
    }

    .ap-loader-text {
        margin: -7px 0;
        font-size: 18px;
        font-weight: bold;
        color: #626262;
    }

    .ap-table-uuid-holder {
        padding: 10px;
        background-color: #626262;
        color: white;
        font-weight: bold;
        cursor: pointer;
        text-align: center;
        display: grid;
        grid-template-columns: auto auto;
        width: 61px;
        -webkit-transition: background-color 0.2s ease-out;
        -moz-transition: background-color 0.2s ease-out;
        -o-transition: background-color 0.2s ease-out;
        transition: background-color 0.2s ease-out
    }

    .ap-table-uuid-holder:hover {
        background-color: #d83336;
    }

    .profile-btn-grid {
        display: grid;
        grid-template-columns: auto auto;
        margin: 30px;
    }

    .confirmation-btn-grid {
        display: grid;
        grid-template-columns: auto auto;
        margin: 30px;
        grid-column-gap: 10px;
    }

    .profile-btn {
        margin: 0 5px 5px 0;
        width: auto;
    }

    .button-logout {
        margin: 0 5px 5px 0;
        background-color: #e4373a;
        width: 140px;
    }

    .button-logout:hover {
        background-color: #8a0a1f;
    }

    .no-right-margin {
        margin-right: 0 !important;
    }

    .hide-underline {
        text-decoration: none;
    }

    .form-alert-danger{
        font-size: 13px;
        color: #d83336;
        /*margin: 5px 30px;*/
        margin: 7px 0
    }

    .modal-img-block {
        display: inline-block;
        margin: 5px;
        width: 131px;
        height: 74px;
        border-radius: 4px;
        border: 2px solid #f2f2f2;
    }

    .modal-img-block:hover {
        border: 2px solid #bdbdbd;
    }

    .modal-img-block:active {
        border: 2px solid #d83336;
    }

    .modal-img-block-image {
        width: 100%;
        height: 100%;
        border-radius: 2px;
        object-fit: cover;
        object-position: 0 0;
    }

    .ap-modal-title-big {
        padding: 21px 30px;
        font-weight: bold;
        font-size: 22px;
        color: #303030;
    }

    .ap-modal-input-name {
        position: relative;
        font-size: 14px;
        background-color: white;
        color: #939393;
        padding: 2px;
        top: 11px;
        left: 7px;
        width: max-content;
        z-index: 2;
    }

    .ap-button-edit-category {
        display: inline-flex;
        color: #303030;
        cursor: pointer;
        user-select: none;
    }

    .ap-button-edit-category-svg {
        color: #ACACAC;
    }

    .ap-button-edit-category-text {
        padding: 0 10px;
    }

    .ap-button-edit-category:hover .ap-button-edit-category-svg {
        color: #727272;
    }

    .ap-button-edit-category:active .ap-button-edit-category-svg {
        color: #A3A3A3;
    }

    .ap-modal-title-medium {
        /*font-size: 18px;*/
        font-weight: bold;
        margin: 15px 30px 5px 30px;
    }

    .ap-product-modal-grid {
        display: grid;
        grid-template-columns: 60% 40%;
        grid-column-gap: 0;
    }

    .ap-change-photo-anchor {
        position: relative;
        top: 10px;
        left: 195px;
        width: 0;
        height: 0;
    }

    .ap-change-photo-btn{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #ffffff;
        /*opacity: 0.2;*/
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ACACAC;
    }

    .ap-change-photo-btn:hover {
        cursor: pointer;
        color: #727272;
    }
    .ap-change-photo-svg {
        /*opacity: 1;*/
        /*width: 70%;*/
    }

    .ap-modal-text {
        margin: 10px 0;
        color: #303030;
    }

    .vs__dropdown-menu {
        /*z-index: 4000 !important;*/
        position: relative;
        display: block;
        /*overflow: visible;*/
    }

    .edit-project-name-container {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ACACAC;
        cursor: pointer;
    }

    .edit-project-name-container:hover {
        color: #A3A3A3;
    }

    .edit-project-name-container:active {
        color: #ACACAC;
    }

    .photo-sidebar-rename-project {
        padding: 7px 10px 7px 10px;
        border: 1px solid #BDBDBD;
        width: -moz-available;
        width: available;
        width: -webkit-fill-available;

    }

    .photo-sidebar-rename-project:hover {
        border-color: #828282;
    }

    .photo-sidebar-rename-project:focus {
        border-color: #828282;
    }

    .lb-checkbox {
        position: relative;
        margin: auto;
    }

    .temp-btn {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
    }

    .svg-configurator-edit {
        width: 24px;
        height: 24px;
    }

    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gl-square-btn {
        border-radius: 5px;
        text-transform: uppercase;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        user-select: none;
        padding: 11px 31px;
        font-size: 14px;
        transition: all 0.35s ease;
    }

    .btn-disabled {
        color: white;
        border: 2px solid #bdbdbd !important;
        background-color: #bdbdbd !important;
        cursor: not-allowed;
    }

    .btn-red {
        color: white;
        border: 2px solid #cf2c2f;
        background-color: #cf2c2f;
    }

    .btn-red:hover {
        background-color: #ad0e27;
        border-color: #ad0e27;
    }

    .btn-grey {
        color: white;
        border: 2px solid #4b4b4b;
        background-color: #4b4b4b;
    }

    .btn-grey:hover {
        background-color: #303030;
        border-color: #303030;
    }

    .btn-grey-outline {
        color: #4b4b4b;
        border: 2px solid #4b4b4b;
        background-color: white;
    }

    .btn-grey-outline:hover {
        color: #303030;
        border-color: #303030;
    }

    .lite-result-buttons-grid {
        display: grid;
        align-items: center;
        grid-template-columns: max-content auto max-content;
        height: 100%;
        position: relative;
        padding: 0 20px;
    }

    .clickable {
        cursor: pointer;
        user-select: none;
    }

    .margin-30 {
        margin: 30px;
    }

    .button-alert-grid {
        display: grid;
        grid-template-columns: max-content auto;
    }
</style>
